import React,{Fragment, useEffect,useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {createGradient, deleteGradient, getGradients, updateGradient} from '../../actions/gradientAction';
import {AddGradientContainer,Container,GradientBox,GradientChips,Gradient,FormColumn,Form,Button,Grid,Edit} from '../../styles/AddGradient-Styles.js';


const AddGradient = () =>{

    const [name,setName] = useState("");
    const [startcolor,setStartcolor] = useState("");
    const [endcolor,setEndcolor] = useState("");
    const [direction,setDirection] = useState("");
    const [currentGradient, setCurrentGradient] = useState(null);
    // eslint-disable-next-line no-unused-vars
    const [positions,setPositions] = useState(["to bottom",
    "to top",
    "to left",
    "to right",
    "to top left",
    "to top right",
    "to bottom left",
    "to bottom right",]
    );
    const dispatch = useDispatch();
    const gradients = useSelector((state)=>state.gradient.gradients);
    useEffect(()=>{
        dispatch(getGradients());
    },[dispatch]);

    const onSubmit = (e) =>{
        e.preventDefault();
        const gradient = {
            name: name,
            colors:{
                direction: direction,
                start: startcolor,
                end: endcolor
            }
        }
        if (currentGradient == null){
            dispatch(createGradient(gradient));
            setName("")
            setEndcolor("")
            setStartcolor("")
            setDirection("")

        }
        else{
            dispatch(updateGradient(Object.assign(currentGradient, gradient)));
        }
        setCurrentGradient(null);
    }

    const editGradient = (gradient) => {
        setCurrentGradient(gradient);
    }

    useEffect(() =>{
        if(currentGradient !=null){
            setName(currentGradient.name)
            setEndcolor(currentGradient.colors.end)
            setStartcolor(currentGradient.colors.start)
            setDirection(currentGradient.colors.direction)
        }
        else{
            setName("")
            setEndcolor("")
            setStartcolor("")
            setDirection("")
        }
    },[currentGradient])
    return(
        <AddGradientContainer>
        <Container>
        <Gradient>
        { gradients.map((gradient)=>(
                <div className="column is-3" key={gradient._id}>
                <GradientChips 
                direction={gradient.colors.direction}
                start={gradient.colors.start}
                end={gradient.colors.end}
                className="box"> 
                 <div className="buttons">
                        <Edit className="" color={'#ffc107'} hover={'#E0A800'} onClick={()=>editGradient(gradient)}><span className={'material-icons'}>edit</span></Edit>
                        <Edit className="" color={'#dc3545'} hover={'#C82333'} onClick={()=>dispatch(deleteGradient(gradient._id))}><span className={'material-icons'}>delete</span></Edit>
                    </div>
                </GradientChips>
                </div>   
            ))
            }
        </Gradient>
        <FormColumn>
        <Form onSubmit={onSubmit}>
                    <label class="label">Gradient Name</label>
                    <input type="text" value={name} onChange={(e)=>setName(e.target.value)} placeholder="Enter Your Gradient Name"/>
                    <label class="label">First Color</label>
                    <input type="text" value={startcolor} onChange={(e)=>setStartcolor(e.target.value)} placeholder="Enter Your First Color"/>
                    <label class="label">Last Color</label>
                    <input type="text" value={endcolor} onChange={(e)=>setEndcolor(e.target.value)} placeholder="Enter Your Last Color"/>  
                            <Grid>
                            {   startcolor &&
                                endcolor &&
                                positions.map((position)=>(
                                        <GradientBox direction={position} start={startcolor} end={endcolor} onClick={()=>setDirection(position)} className="box has-text-white has-text-centered">
                                            {position}
                                        </GradientBox>
                                ))
                            }
                            </Grid>
                        {
                            currentGradient ? (
                                <Fragment>
                                <Button color={'#ffc107'} hover={'#E0A800'}>Update Gradient</Button>
                                <Button color={'#dc3545'} hover={'#C82333'} onClick={() => setCurrentGradient(null)}>Cancel</Button>
                                </Fragment>
                            )
                            : (
                                <Button color={'green'}>Create Gradient</Button>
                            )
                        }
                    </Form>
                    </FormColumn>
                    </Container>
                    </AddGradientContainer>
    )
}

export default AddGradient;